export const UNKNOWN_ERROR = 'An unknown error occurred. BLINK has been notified and will investigate the error.';
